import styled from "styled-components";

const Container = styled.div<{ visible: boolean }>`
  display: flex;
  align-items: center;

  ${({ visible }) => !visible && `visibility: hidden;`}
`;

const Description = styled.div`
  margin: 0 1rem;
`;

export { Container, Description };
